import React from "react";
import AssetCategoryPage from "./AssetCategoryPage";

const LandscapingAssets = () => {
  return <AssetCategoryPage category="Landscaping" title="Landscaping" />;
};

export default LandscapingAssets;
